import { Icon, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, cn } from "@nexus/ui"
import { useTranslation } from "react-i18next"

export type OpportunitiesView = "table" | "card"

const VIEWS: { value: OpportunitiesView; icon: "rows-3" | "layout-grid" }[] = [
  { value: "table", icon: "rows-3" },
  { value: "card", icon: "layout-grid" },
]

export interface ViewToggleProps {
  value: OpportunitiesView
  onChange: (value: OpportunitiesView) => void
}

export function ViewToggle({ value, onChange }: ViewToggleProps) {
  const { t } = useTranslation()

  return (
    <TooltipProvider delayDuration={400}>
      <div className="inline-flex items-center rounded-md border border-primary/30 shadow-xs dark:border-primary/40">
        {VIEWS.map((v) => (
          <Tooltip key={v.value}>
            <TooltipTrigger asChild>
              <button
                type="button"
                onClick={() => onChange(v.value)}
                aria-pressed={value === v.value}
                className={cn(
                  "inline-flex h-8 w-8 items-center justify-center text-sm transition-colors first:rounded-l-md last:rounded-r-md",
                  value === v.value
                    ? "bg-primary/10 text-primary dark:bg-primary/20"
                    : "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
                )}
              >
                <Icon name={v.icon} size="xs" color="inherit" />
              </button>
            </TooltipTrigger>
            <TooltipContent>{t(`opportunities.view.${v.value}`)}</TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  )
}
